import { useEffect } from 'react'
import { errorLogger } from '@chegg-wt/core/utils/errors'

const useErrorLogger = () => {
  useEffect(errorLogger, [])
}

export default useErrorLogger
